import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Flex } from '@/ui/Flex/Flex';
import { Tag } from '@/ui/Tag/Tag';
import { T } from '@/ui/Text/Text';

const StyledCalcWrapper = styled.div`
  background-color: ${({ theme }) => theme.color('#FFFFFF')};
  border-radius: 9px;
  padding: 1px 4px;
`;

type Props = {
  readonly playerTotals: {
    readonly online: number;
    readonly total: number;
  };
};

export const StatusTag = ({ playerTotals }: Props) => {
  let content;

  if (playerTotals.online === 0) {
    content = (
      <Tag color="#E0E0E0">
        <T body2>
          <FormattedMessage defaultMessage="Offline" id="7UOvbT" />
        </T>
      </Tag>
    );
  } else if (playerTotals.online < playerTotals.total) {
    content = (
      <Tag color="#FFC48E" narrow>
        <Flex align="center" gap={8} justify="space-between">
          <T body2>
            <FormattedMessage defaultMessage="Online" id="ccU6l/" />
          </T>
          <StyledCalcWrapper>
            <FormattedMessage
              defaultMessage="{online}/{total}"
              id="/bhJG5"
              values={{
                online: playerTotals.online,
                total: playerTotals.total,
              }}
            />
          </StyledCalcWrapper>
        </Flex>
      </Tag>
    );
  } else {
    content = (
      <Tag color="#C4FBD1">
        <T body2>
          <FormattedMessage defaultMessage="Online" id="ccU6l/" />
        </T>
      </Tag>
    );
  }

  return (
    <div>
      {content}
      {/* {playerTotals.online === playerTotals.total &&
    playerTotals.online !== 0 &&
    playerTotals.total !== 0 ? (
      <Tag color="#C4FBD1">
        <T body2>
          <FormattedMessage defaultMessage="Online" id="ccU6l/" />
        </T>
      </Tag>
    ) : playerTotals.online === 0 ? (
      <Tag color="#E0E0E0">
        <T body2>
          <FormattedMessage defaultMessage="Offline" id="7UOvbT" />
        </T>
      </Tag>
    ) : (
      <Tag color="#FFC48E" narrow>
        <Flex align="center" gap={8} justify="space-between">
          <T body2>
            <FormattedMessage defaultMessage="Online" id="ccU6l/" />
          </T>
          <StyledCalcWrapper>
            <FormattedMessage
              defaultMessage="{online}/{total}"
              id="/bhJG5"
              values={{
                online: playerTotals.online,
                total: playerTotals.total,
              }}
            />
          </StyledCalcWrapper>
        </Flex>
      </Tag>
    )} */}
    </div>
  );
};
